import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import {
  CirculatingWalletLiveViewResponse,
  CollectorWalletLiveViewResponse,
  GeneralWalletLiveViewResponse,
  WalletLiveViewConnectionState,
  WalletRechargesLiveViewResponse,
} from "../../../domain/models/accounting/wallet-live-view.model";
import { WalletLiveViewPort } from "../../../app/ports/accounting/wallet-live-view.port";

@Injectable()
export class MockWalletLiveViewAdapter implements WalletLiveViewPort {
  private readonly collectorSubject = new Subject<CollectorWalletLiveViewResponse>();
  private readonly walletRechargesSubject = new Subject<WalletRechargesLiveViewResponse>();
  private readonly circulatingSubject = new Subject<CirculatingWalletLiveViewResponse>();
  private readonly generalSubject = new Subject<GeneralWalletLiveViewResponse>();
  private readonly connectionStateSubject = new Subject<WalletLiveViewConnectionState>();

  readonly collector$ = this.collectorSubject.asObservable();
  readonly walletRecharges$ = this.walletRechargesSubject.asObservable();
  readonly circulating$ = this.circulatingSubject.asObservable();
  readonly general$ = this.generalSubject.asObservable();
  readonly connectionState$ = this.connectionStateSubject.asObservable();

  connect(companyCode: string): void {
    if (companyCode.trim().toUpperCase() !== "INCLUB") return;
    const lastReceivedAt = new Date().toISOString();
    this.generalSubject.next({
      idCompany: 5,
      idAccountingDay: 42,
      idCurrency: 1,
      availableAmount: 600_000,
      provisionAmount: 0,
      accountingAmount: 0,
      sourceTotal: 0,
      calculatedTotal: 0,
      differenceAmount: 0,
    });
    this.circulatingSubject.next({
      idCompany: 5,
      idAccountingDay: 42,
      idCurrency: 1,
      totalAmount: 600_000,
      variationPercentage: null,
      previousPeriod: null,
      companyWallets: { amount: 0, percentage: 0, variationPercentage: null },
      memberWallets: { amount: 0, percentage: 0, variationPercentage: null },
      availableWallets: { amount: 600_000, percentage: 100, variationPercentage: null },
    });
    this.collectorSubject.next({
      idCompany: 5,
      idAccountingDay: 42,
      idCurrency: 1,
      totalAmount: 24_850.75,
      details: [
        { idFinancialInstitution: 10, idCurrency: 1, amount: 15_000 },
      ],
    });
    this.walletRechargesSubject.next({
      idCompany: 5,
      idAccountingDay: 42,
      currency: { id: 2, code: "USD", name: "Dólar estadounidense" },
      totalAmount: 0,
      details: [],
    });
    (["collector", "wallet-recharges", "circulating", "general"] as const).forEach((channel) => {
      this.connectionStateSubject.next({
        channel,
        status: "connected",
        reconnectAttempt: 0,
        lastReceivedAt,
        error: null,
      });
    });
  }

  disconnect(): void {
    (["collector", "wallet-recharges", "circulating", "general"] as const).forEach((channel) => {
      this.connectionStateSubject.next({
        channel,
        status: "idle",
        reconnectAttempt: 0,
        lastReceivedAt: null,
        error: null,
      });
    });
  }
}

